const FOCUSABLE_SELECTOR =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
const TEXT_ENTRY_SELECTOR = 'input, select, textarea, [contenteditable="true"]'
const ARROW_KEY_DIRECTIONS = {ArrowLeft: -1, ArrowRight: 1}

// Array.from, not spread: the package build compiles spread to `[].concat`, which does not expand DOM collections.
const getFocusables = card => Array.from(card.querySelectorAll(FOCUSABLE_SELECTOR))

// Moves focus to the same stop (link, favorite button...) of the adjacent card, so the arrow keys land
// on the same kind of control instead of always on the card's first one.
export default function focusSiblingCard(event) {
  const direction = ARROW_KEY_DIRECTIONS[event.key]
  const hasModifier = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey

  if (!direction || hasModifier || event.target.matches(TEXT_ENTRY_SELECTOR)) return

  const card = Array.from(event.currentTarget.children).find(child => child.contains(event.target))
  const stopIndex = card ? getFocusables(card).indexOf(event.target) : -1

  if (stopIndex === -1) return

  const siblingKey = direction > 0 ? 'nextElementSibling' : 'previousElementSibling'

  for (let sibling = card[siblingKey]; sibling; sibling = sibling[siblingKey]) {
    const siblingFocusables = getFocusables(sibling)

    if (siblingFocusables.length) {
      event.preventDefault()
      siblingFocusables[Math.min(stopIndex, siblingFocusables.length - 1)].focus()
      return
    }
  }
}
